import { render } from "./BuilderRequestMessageModal.vue?vue&type=template&id=0384efd5&scoped=true&ts=true&lang=pug"
import script from "./BuilderRequestMessageModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderRequestMessageModal.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderRequestMessageModal.vue?vue&type=style&index=0&id=0384efd5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0384efd5"]])

export default __exports__